module.exports = __webpack_public_path__ + "static/img/BG.bcdb8aec.png";